import { nanoid } from "@reduxjs/toolkit";
import React, { ChangeEventHandler, useEffect, useMemo, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import Option from "../components/Option";
import { getOnlyUnique } from "../components/commonWidget";
import chartIcon from "../components/custom/assets/images/dashboard/chart_icon.svg";
import downIcon from "../components/custom/assets/images/dashboard/down-icon.svg";
import tableIcon from "../components/custom/assets/images/dashboard/table_icon.svg";
import upIcon from "../components/custom/assets/images/dashboard/up-icon.svg";
import { MultiSelect } from "../components/custom/components";
import { FormInput } from "../components/custom/components";
import FormInput2 from "../components/custom/components/FormInput2";
import {
  Tbody,
  Thead,
} from "../components/custom/components/TradeCategoryPerformanceTable";
import TransactionTable from "../components/custom/components/TransactionTable";
import PieChart1 from "../components/custom/components/charts/apex/PieChart1";
import { COLORS } from "../components/custom/constants";
import UserLayout from "../components/custom/layouts/UserLayout";
import { ToastTypes, useToast } from "../components/toast/ToastProvider";
import { defaultLocation, defaultPortfolio, DropDownOption1, PAGE_SIZE, WEEK_DAYS } from "../config";
import api, { APIResponse, getAxiosRequestConfig } from "../config/api";
import {
  CSVdownload,
  handleDownloadPDF,
} from "../config/functions";
import { AuthUserType } from "../redux/actions/authUserActions";
import { PortfolioType } from "../redux/actions/portfolioActions";
import {
  OptionsTypes,
  addToSelectedOption,
} from "../redux/actions/selectedOptionsActions";
import { SiteType } from "../redux/actions/siteActions";
import { TradeCategoryType } from "../redux/actions/tradeCategoryActions";
import { StoreState } from "../redux/store";
import Loader from "../components/custom/components/Loader";
import Modal from "../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowMaximize } from "@fortawesome/free-solid-svg-icons";
import { areaType } from "../redux/actions/areaActions";
import { outletType } from "../redux/actions/outletActions";
import { useLocation } from "react-router-dom";
import { UserLog } from "../config/common";
import SingleSelect from "../components/custom/components/SingleSelect";
import SingleSelect1 from "../components/custom/components/SingleSelect1";

export interface DropDownOption {
  value: number;
  label: string;
  imgUrl: string;
}

export interface WeekendAnalysisRecord {
  category: number;
  sales: string;
  transyear: number;
  transweek: number;
  percentchange: string | null;
}

export interface WeekendAnalysisReportType {
  portfolio: number;
  record: WeekendAnalysisRecord[];
  count?: number;
}

const SalesWeekendAnalysisReport: React.FC = () => {
  const toast = useToast();
  const dispatch = useDispatch();
  const pageName = useLocation()
  const authUser = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  );
  const authUserToken = useSelector<StoreState, AuthUserType | null>(
    (state) => state?.authUser
  )?.["auth-token"]!;
  const config = getAxiosRequestConfig(authUserToken);

  const authUserSiteId = authUser?.siteId;

  const portfolioOption = useSelector<StoreState, PortfolioType[]>(
    (state) => state?.portfolio
  );
  const siteOption = useSelector<StoreState, SiteType[]>((state) => state?.site);
  const selectedOption = useSelector<StoreState, OptionsTypes>(
    (state) => state?.selectedOption
  );
  const localityOption = useSelector<StoreState, areaType[]>(
    (state) => state?.locality
  );
  const outletList = useSelector<StoreState, outletType[]>(
    (state) => state?.outlet
  );

  const weekArray = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
  ];

  const port =
    authUser?.portfolioId !== undefined && authUser?.portfolioId !== null
      ? authUser?.portfolioId?.split(",")
      : [];

  let portfolioData = port
    ?.map((pe) => {
      return portfolioOption?.filter(
        (f) => f?.id?.toString() === pe?.toString()
      );
    })
    ?.flat(1);

  const pname = portfolioData[0]?.name;

  const st =
    authUser?.siteId !== undefined && authUser?.siteId !== null
      ? authUser?.siteId?.split(",")
      : [];

  let siteData = st
    ?.map((pe) => {
      return siteOption?.filter((f) => f?.id?.toString() === pe?.toString());
    })
    ?.flat(1);

  const categoryOption = useSelector<StoreState, TradeCategoryType[]>(
    (state) => state?.tradeCategory
  );
  const [year, setYear] = useState<Date>(new Date());
  const [week, setWeek] = useState<string>("1");
  const [weekDays, setWeekDays] = useState<string[]>(WEEK_DAYS);

  const [valueIn, setValueIn] = useState<string>("");

  const [portfolios, setPortfolios] = useState<string>("");
  const [sites, setSites] = useState<string>("");
  const [brands, setBrands] = useState<string>("");

  const [location, setLocation] = useState<string>("");
  // const [locations, setLocations] = useState<DropDownOption[]>([]);
  const [categories, setCategories] = useState<string>("");
  const [subCategories, setSubCategories] = useState<string>("");
  const [disableLocality, setDisableLocality] = useState<boolean>(false);
  //loader
  const [loader, setLoader] = useState<boolean>(false);
  const [pag, setPag] = useState<boolean>(false);

  const [weekendAnalysisData, setWeekendAnalysisData] = useState<
    WeekendAnalysisReportType[]
  >([]);

  const limit = PAGE_SIZE;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(50);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [condition,setCondition] = useState<boolean>(false)

  
  const [portfoliosOption, setPortfoliosOption] = useState<DropDownOption1>(defaultPortfolio);
  const  [locationOption,setLocationOption] = useState<DropDownOption1>(defaultLocation)

  const [portfolioDrop, setPortfolioDrop] = useState<DropDownOption[]>([]);
  const [locationDrop, setLocationDrop] = useState<DropDownOption[]>([]);

  const showExpandModalHandler = () => {
    setShowModal(true)
  };

  const handleSelectedRowsChange = (selectedRows: string[]) => {
    setSelectedRows(selectedRows);
  };
  
  const handleOff = (conditionVal: boolean) => {
    setCondition(conditionVal);
  };

  const SiteFilteredByPortfolio = useMemo<SiteType[]>(() => {
    if (portfolios !== "") {
      return siteData?.filter((s) => {
        return s?.pfid?.toString() === portfolios?.toString();
      });
    } else return [];
  }, [portfolios, siteData]);
  // const locality = useMemo<string[]>(() => {
  //   return locations?.map((p) => {
  //     return p?.label;
  //   });
  // }, [locations]);
  const handleWeek: ChangeEventHandler<HTMLInputElement> = (e) => {
    setWeek(e?.target?.value);
    setPag(false);
  };

  const handlePortfolioDrop = (selected: any) => {
    if(selected.length>0){
      const selectedPortfolio = selected as DropDownOption[];
      if(selectedPortfolio[0].value!==null&&selectedPortfolio[0].value!==0){
        setPortfolioDrop(selectedPortfolio)
        setPortfolios(selectedPortfolio[0]?.value?.toString())
        const data = { ...selectedOption, portfolio: selectedPortfolio[0]?.value?.toString() };
        dispatch(addToSelectedOption(data));
        setOffset(0);
        setPag(false)
      }
  }
  };
  
  const handleClearPortfolio = () =>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
      setLocation("");
      setLocationDrop([])
      const data = { ...selectedOption, portfolio: b[0]?.id?.toString(),location:''};
      dispatch(addToSelectedOption(data));
      setOffset(0);
      setPag(false);
  }
  }
  
  
  const handleLocationDrop = (selected: any) => {
    if(selected.length>0){
      const selectedLocation = selected as DropDownOption[];
      if(selectedLocation[0].value!==null&&selectedLocation[0].value!==0){
        setLocationDrop(selectedLocation)
        setLocation(selectedLocation[0]?.label?.toString())
       const data = { ...selectedOption,location: selectedLocation[0]?.label?.toString()};
       dispatch(addToSelectedOption(data));
       setOffset(0);
       setPag(false)
      }
    }
  };
  
  const handleClearLocation = () =>{
       setLocationDrop([])
       setLocation('')
       const data = { ...selectedOption,location: ""};
       dispatch(addToSelectedOption(data));
       setOffset(0);
       setPag(false)
  }


  const portFilter = portfolioOption?.filter((a)=>a?.id?.toString()===portfolios?.toString())
  
  const localityFilter = localityOption?.filter((a)=>a?.area?.toString()===location?.toString())


  const combinedValues = [
    ...portFilter?.map(a => `Portfolio: ${a?.name}`),           
    ...localityFilter?.map(f=>`Locality: ${f?.area}`),     
    `Year: ${year?.getFullYear()}`,`Week: ${week}`
  ]
  ?.filter(name => name && name?.trim() !== '') 
  ?.join(', ');  
  





  const tHead = useMemo<Thead[]>(() => {
    var tableHead: Thead[] = [{ id: "Date", children: "Date", text: "Date" }];

    let arr = [new Date(year)?.getFullYear() - 1, new Date(year)?.getFullYear()];
    arr?.forEach((y) => {
      tableHead?.push(
        {
          children: y?.toString(),
          text: y?.toString(),
          id: y?.toString(),
        },
        {
          children: y + " % Change",
          text: y + " % Change",
          id: y + " % Change",
        }
      );
    });

    return tableHead;
  }, []);

  const getDownloadData = (Data: WeekendAnalysisReportType[]) => {
    var tableHead: Thead[] = [
      { id: "Category", children: "Category", text: "Category" },
    ];
    var tableBody: Tbody[][] = [];
    let arr = [new Date(year)?.getFullYear() - 1, new Date(year)?.getFullYear()];
    arr?.forEach((y) => {
      tableHead?.push(
        {
          children: y?.toString(),
          text: y?.toString(),
          id: y?.toString(),
        },
        {
          children: y + " % Change",
          text: y + " % Change",
          id: y + " % Change",
        }
      );
    });

    Data?.forEach((y, i) => {

      const catArray = y?.record?.map((r, j) => r?.category)?.filter(getOnlyUnique);

      catArray?.forEach((cat, j) => {
        var tBody: Tbody[] = [];
        const categoryIndex = categoryOption?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === cat?.toString()
        );
        const categoryName = categoryOption[categoryIndex]?.name;

        const categoryId = cat;
        tBody?.push({
          id: "Category" + categoryId + j,
          theadId: "Category",
          children: categoryName,
          text: categoryName,
        });

        y?.record
          ?.filter((r) => r?.category?.toString() === categoryId?.toString())
          ?.forEach((r, i) => {
            tBody?.push(
              {
                id: nanoid(),
                children: r?.sales,
                text: r?.sales,
                theadId: r?.transyear?.toString(),
              },
              {
                id: nanoid(),
                children:
                  r?.percentchange !== undefined && r?.percentchange !== null ? (
                    <div
                      className={
                        r?.percentchange !== undefined &&
                        r?.percentchange !== null
                          ? parseFloat(r?.percentchange) > 0
                            ? "p-mtd text-success text-truncate"
                            : parseFloat(r?.percentchange) < 0
                            ? "n-mtd text-danger text-truncate"
                            : ""
                          : ""
                      }
                    >
                      {parseFloat(r?.percentchange) > 0 ? (
                        <i>
                          <img src={upIcon} alt="icon"></img>{" "}
                          {r?.percentchange?.toString() || ""}
                        </i>
                      ) : parseFloat(r?.percentchange) < 0 ? (
                        <i>
                          <img src={downIcon} alt="icon"></img>{" "}
                          {r?.percentchange?.toString() || ""}
                        </i>
                      ) : (
                        r?.percentchange?.toString()
                      )}
                    </div>
                  ) : (
                    ""
                  ),
                text: r?.percentchange?.toString(),
                theadId: r?.transyear + " % Change",
              }
            );
          });
        tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  useEffect(() => {
    const header = tHead
      ?.map((a) => a?.text)
      ?.filter((id): id is string => typeof id === "string" && id !== undefined);
    setSelectedRows(header);
  }, []);

  const handleApply = () => {
    let error = false;
    if (portfolios === "") {
      toast("Select Portfolio", ToastTypes?.ERROR);
      error = true;
    }
    else if (week === "") {
      toast("Select week", ToastTypes?.ERROR);
      error = true;
    } else if (
      year === null ||
      (year !== null && year?.getFullYear()?.toString() === "")
    ) {
      toast("Select year", ToastTypes?.ERROR);
      error = true;
    }
    var getData = {
      portfolio: portfolio,
      site: site,
      // locality: locality,
      locality: location===defaultLocation?.label?'':location,
      year: year?.getFullYear(),
      weekNo: week,
      weekDays: weekDays,
      limit: limit?.toString(),
      offset: offset?.toString(),
      authUserRole: authUser?.roleId ? authUser?.roleId : "",
    };
    if (pag === false) {
      setLoader(true);
    }

    if (
      error === false &&
      getData !== undefined &&
      getData?.limit !== "" &&
      getData?.offset !== ""
    ) {
      api
        .post<APIResponse<{ records: WeekendAnalysisReportType[] }>>(
          `kpi/sales/weeklyAnalysis`,
          getData,
          config
        )
        .then((response) => {
          if (response?.status === 200 && response?.data?.data) {
            const result = response?.data?.data?.records;
            setLoader(false);
            setPag(true);
            setWeekendAnalysisData(result);
            setCondition(false)
            if(authUser){
              const logProps1 = {
                action: 'Apply',
                event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Apply Clicked | Data Status: ${result?.[0]?.count && result[0]?.count > 0 ? 'Success' : 'Empty'}`
              };
              UserLog(logProps1)
            }
          }
          else {
            setWeekendAnalysisData([]);
            setLoader(false);
            setPag(true);
            setCondition(false)
          }
        })
        .catch((error) => {});
    } 
   
  };

  const handlePag = () => {
    setPag(true);
  };

  useEffect(() => {
    if (portfolios !== "") handleApply();
    if (location !== "") handleApply();
  }, [portfolios,location]);

  const handleCsvDownload = async () => {
    let Data = weekendAnalysisData;

    const d = { ...getDownloadData(Data) };

    const filteredHead = d?.thead
      ?.map((a) => {
        const foundObject = selectedRows
          ?.map((b) => {
            if (a?.text?.toString() === b?.toString()) {
              return a;
            }
          })
          ?.find((obj) => obj !== undefined);

        if (foundObject !== undefined) {
          return foundObject;
        }
      })
      ?.filter((obj) => obj !== undefined);
    const csvHead = filteredHead;
    const csvBody = d?.tbody;

    const head = [csvHead?.map((h) => h?.text || "") || []];
    const body =
      csvBody?.map((tr, i) => {
        return (
          csvHead?.map((th, j) => {
            const col = tr?.find((r) => r?.theadId === th?.id);
            return col?.text || "";
          }) || []
        );
      }) || [];

    const rows = [...head, ...body];
    const props = {
      rows: rows,
      fileName: "Weekend Analysis Report",
    };
    CSVdownload(props);
    if(authUser){
      const logProps1 = {
        action: 'Csv',
        event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Csv Clicked | Export Status: Success | Data Status: Success`
      };
      UserLog(logProps1)
    }
  };

  const handlePdfDownload = async () => {
    let Data = weekendAnalysisData;

    const d = { ...getDownloadData(Data) };
    const filteredHead = d?.thead
      ?.map((a) => {
        const foundObject = selectedRows
          ?.map((b) => {
            if (a?.text?.toString() === b?.toString()) {
              return a;
            }
          })
          ?.find((obj) => obj !== undefined);

        if (foundObject !== undefined) {
          return foundObject;
        }
      })
      ?.filter((obj) => obj !== undefined);
    const thead = filteredHead;
    const tbody = d?.tbody;

    const head = [thead?.map((h) => h?.text || "") || []];
    const body =
      tbody?.map((tr, i) => {
        return (
          thead?.map((th, j) => {
            const col = tr?.find((r) => r?.theadId === th?.id);
            return col?.text || "";
          }) || []
        );
      }) || [];

    const props = {
      head: head,
      body: body,
      fileName: "Weekend Analysis Report",
      title: "Weekend Analysis Report",
    };
    handleDownloadPDF(props);
    if(authUser){
      const logProps1 = {
        action: 'Pdf',
        event: `${pageName?.pathname?.replace("\\", " ")} page | Filters - ${combinedValues} | Pdf Clicked | Export Status: Success | Data Status: Success`
      };
      UserLog(logProps1)
    }
  };

  const getTableData = () => {
    var tableHead: Thead[] = [
      { id: "Category", children: "Category", text: "Category" },
    ];
    var tableBody: Tbody[][] = [];

    let Data = weekendAnalysisData;
    let arr = [new Date(year)?.getFullYear(), new Date(year)?.getFullYear() - 1];
    arr?.forEach((y) => {
      tableHead?.push(
        {
          children: y?.toString(),
          text: y?.toString(),
          id: y?.toString(),
        },
        {
          children: y + " % Change",
          text: y + " % Change",
          id: y + " % Change",
        }
      );
    });

    Data?.forEach((y, i) => {
      const catArray = y?.record?.map((r, j) => r?.category)?.filter(getOnlyUnique);

      catArray?.forEach((cat, j) => {
        var tBody: Tbody[] = [];
        const categoryIndex = categoryOption?.findIndex(
          (c) => c?.id !== undefined && c?.id?.toString() === cat?.toString()
        );
        const categoryName = categoryOption[categoryIndex]?.name;
        const categoryId = cat;

        tBody?.push({
          id: "Category" + categoryId + j,
          theadId: "Category",
          children: categoryName,
          text: categoryName,
        });

        y?.record
          ?.filter((r) => r?.category?.toString() === categoryId?.toString())
          ?.forEach((r, i) => {
            tBody?.push(
              {
                id: nanoid(),
                children: r?.sales,
                text: r?.sales,
                theadId: r?.transyear?.toString(),
              },
              {
                id: nanoid(),
                children:
                  r?.percentchange !== undefined && r?.percentchange !== null ? (
                    <div
                      className={
                        r?.percentchange !== undefined &&
                        r?.percentchange !== null
                          ? parseFloat(r?.percentchange) > 0
                            ? "p-mtd text-success text-truncate"
                            : parseFloat(r?.percentchange) < 0
                            ? "n-mtd text-danger text-truncate"
                            : ""
                          : ""
                      }
                    >
                      {parseFloat(r?.percentchange) > 0 ? (
                        <i>
                          <img src={upIcon} alt="icon"></img>{" "}
                          {r?.percentchange?.toString() || ""}
                        </i>
                      ) : parseFloat(r?.percentchange) < 0 ? (
                        <i>
                          <img src={downIcon} alt="icon"></img>{" "}
                          {r?.percentchange?.toString() || ""}
                        </i>
                      ) : (
                        r?.percentchange?.toString()
                      )}
                    </div>
                  ) : (
                    ""
                  ),
                text: r?.percentchange?.toString(),
                theadId: r?.transyear + " % Change",
              }
            );
          });

        tableBody?.push(tBody);
      });
    });
    return { tbody: tableBody, thead: tableHead };
  };

  const portfolio = useMemo<number[]>(() => {
    return portfolios !== "" ? [parseInt(portfolios)] : [];
  }, [portfolios]);

  const site = useMemo<string[]>(() => {
    if (authUserSiteId) {
      return authUserSiteId?.split(",")?.map((s) => {
        return s?.toString();
      });
    } else {
      return [];
    }
  }, [authUserSiteId]);

  useEffect(() => {
    setOffset(0);
  }, [week, year]);

  useEffect(() => {
    let sid = siteData[0] && siteData[0]?.id ? siteData[0]?.id?.toString() : "";
    setSites(selectedOption?.site ? selectedOption?.site : sid);
  }, [siteData, selectedOption]);

  useEffect(()=>{    
    if(selectedOption?.isOutletUser){
      setDisableLocality(true);
    }
    else{
      setDisableLocality(false);
    }
  },[authUser, outletList,selectedOption]);

  useEffect(()=>{
    let pid =portfolioData[0] && portfolioData[0]?.id? portfolioData[0].id?.toString(): "";
    setPortfolios(selectedOption.portfolio ? selectedOption.portfolio : pid);
    const b = portfolioOption.filter((a)=>a?.id?.toString()===pid?.toString())
    if (b?.length > 0 && b[0]?.id !== undefined) {
      const val: DropDownOption = {
        value: b[0]?.id, 
        label: b[0]?.name,
        imgUrl: b[0]?.logourl, 
      };
      setPortfolioDrop([val]);
    }
},[portfolioOption,selectedOption])

useEffect(()=>{
  setLocation(selectedOption.location? selectedOption.location:'')
  const b = localityOption.filter((a)=>a?.area?.toString()===selectedOption.location?.toString())
  if (b?.length > 0 && b[0]?.id !== undefined) {
    const val: DropDownOption = {
      value: b[0]?.id, 
      label: b[0]?.area,
      imgUrl:'', 
    };
    setLocationDrop([val]);
  }
  },[localityOption,selectedOption])


  useEffect(() => {
    var range = [];
    var num = Math?.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range?.push(i);
    }
    setRange(range);
  }, [length, limit]);

  useEffect(() => {
    if (sites !== ""&&selectedOption.isOutletUser===true) {
      let siteCurrencyObject = siteOption?.find(
        (s) => s?.id?.toString() === sites?.toString()
      );
      setValueIn(
        siteCurrencyObject?.currencycode +
          " | " +
          siteCurrencyObject?.valuecaption
      );
    } 
    else if(portfolios !== ""&&selectedOption.isOutletUser===false){
      let portfolioCurrencyObject = portfolioOption?.find(
        (s) => s?.id?.toString() === portfolios?.toString()
      );
      setValueIn(
        portfolioCurrencyObject?.reportingcurrency +
          " | " +
          portfolioCurrencyObject?.valuecaption
      );
    }
    else setValueIn("");
  }, [sites, siteOption,selectedOption]);

  useEffect(() => {
    if (weekendAnalysisData?.length > 0)
      setLength(
        weekendAnalysisData[0]?.count ? weekendAnalysisData[0]?.count : 0
      );
  }, [weekendAnalysisData]);

  const colors = [
    COLORS?.COLOR1,
    COLORS?.COLOR2,
    COLORS?.COLOR3,
    COLORS?.COLOR4,
    COLORS?.COLOR5,
    COLORS?.COLOR6,
    COLORS?.COLOR7,
    COLORS?.COLOR8,
  ];

  
  useEffect(()=>{
    if(authUser){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName?.pathname?.replace("\\", " ")} page | Visited `
    };
    UserLog(logProps1)
  }
  },[])


  return (
    <UserLayout>
      <div className="card background-transparent p-1">
        <div className="row">
          <div
            className="col-lg-4 wow fadeInLeft ps-0"
          >
            <h4 className="b-title">Weekend Analysis</h4>
          </div>

          <div className="col-lg-8 wow fadeInRight">
            <div className="row">
              <div className="col-sm-6 col-md-4 col-lg-3">
                {/* <FormInput2
                  name="Portfolio"
                  label=""
                  labelClassName="required"
                  value={portfolios}
                  onChange={handlePortfolioChange}
                  placeholder="Select"
                  containerClass="mb-1"
                  type="select"
                >
                  <option value="">Select</option>
                  {portfolioData?.map((p, i) => {
                    return (
                      <Option value={p?.id} key={i}>
                        {p?.name}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                {/* <SingleSelect
                  options={[
                    defaultPortfolio,
                    ...portfolioData?.sort(function (a, b) {
                      if (a?.name < b?.name) {
                        return -1;
                      }
                      if (a?.name > b?.name) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.name,
                          imgUrl: s?.logourl,
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={portfoliosOption}
                  setSelectedOptions={handlePortfolioChange}
                  // disabled={disableSite}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
                  <SingleSelect1
                      options={portfolioData.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.name?c?.name:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={portfolioDrop}
                      setSelectedOptions={handlePortfolioDrop}
                      placeHolder="Select Portfolio"
                      onClear={handleClearPortfolio}
                      disabled = {disableLocality}
                    />
              </div>
              <div className="col-sm-3 col-md-4 col-lg-3">
              {/* <FormInput2
                  name="Location"
                  label=""
                  labelClassName="required"
                  value={location}
                  onChange={handleLocationChange}
                  placeholder="Select Locality"
                  containerClass="mb-1"
                  type="select"
                  disabled={disableLocality}
                >
                  <option value="">Select Locality</option>
                  {localityOption?.map((s, i) => {
                    return (
                      <Option value={s?.area} key={i}>
                        {s?.area}
                      </Option>
                    );
                  })}
                </FormInput2> */}
                 {/* <SingleSelect
                  options={[
                    defaultLocation,
                    ...localityOption?.sort(function (a, b) {
                      if (a?.area < b?.area) {
                        return -1;
                      }
                      if (a?.area > b?.area) {
                        return 1;
                      }
                      return 0;
                    })?.map((s, i) => {
                      return (
                        {
                          value: s?.id ? s?.id?.toString() : '',
                          label: s?.area,
                          imgUrl: '',
                        }
                      );
                    })
                  ]}
                  label=""
                  selectedOptions={locationOption}
                  setSelectedOptions={handleLocationChange}
                  disabled={disableLocality}
                  placeHolder="Select Portfolio"
                  // filterText=""
                /> */}
              {/* <MultiSelect
                  options={localityOption?.map((sc) => {
                    return {
                      value: sc?.id ? sc?.id : 0,
                      label: sc?.area?.toString(),
                      imgUrl: "",
                    };
                  })}
                  label=""
                  selectedOptions={locations}
                  setSelectedOptions={setLocations}
                  disabled={disableLocality}
                  placeHolder="All Locality"
                /> */}
                   <SingleSelect1
                      options={localityOption.map((c, i) => {
                        return {
                          value: c?.id?c?.id:0,
                          label: c?.area?c?.area:'',
                          imgUrl: "",
                        };
                      })}
                      selectedOptions={locationDrop}
                      setSelectedOptions={handleLocationDrop}
                      placeHolder="Select Locality"
                      onClear={handleClearLocation}
                      disabled = {disableLocality}
                    />
              </div>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3 widget_div" onMouseEnter={() => setButtonVisible(true)} onMouseLeave={() => setButtonVisible(false)}>
                {(<button type="button" className="expandIconBtn" onClick={showExpandModalHandler} ><i><FontAwesomeIcon icon={faWindowMaximize} size="lg" title="Open in Popup"/></i></button>)}
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title">
                          <img src={chartIcon} alt="icon"></img>
                          Weekend Analysis
                        </h5>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-md-6">
                        <div className="float-end hstack gap-2">
                          <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <FormInput
                              name="Week"
                              label=""
                              labelClassName="required"
                              value={week}
                              onChange={handleWeek}
                              placeholder="Select Week"
                              containerClass="mb-1"
                              type="select"
                            >
                              <option value="">Select Week</option>
                              {weekArray?.map((s, i) => {
                                return (
                                  <Option value={s} key={i}>
                                    {" "}
                                    {s}
                                  </Option>
                                );
                              })}
                            </FormInput>
                          </div>
                          <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                            <div className="DateContainer">
                              <span className="dateInput">
                                <ReactDatePicker
                                  id="DatePicker"
                                  className="text-center fw-bold form-control"
                                  selected={year}
                                  onChange={(date: any) => setYear(date)}
                                  showYearPicker
                                  dateFormat="yyyy"
                                  yearItemNumber={8}
                                />
                              </span>
                              <span className="icon">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.25 2.6001C14.4709 2.6001 14.65 2.77918 14.65 3.0001V4.26685H16.125C16.7141 4.26685 17.2873 4.47445 17.7165 4.85604C18.1474 5.23898 18.4 5.76918 18.4 6.33351V9.66685V16.3335C18.4 16.8979 18.1474 17.428 17.7165 17.811C17.2873 18.1926 16.7141 18.4002 16.125 18.4002H4.87498C4.28582 18.4002 3.71269 18.1926 3.2834 17.811C2.85259 17.428 2.59998 16.8978 2.59998 16.3335V9.66685V6.33351C2.59998 5.76918 2.85259 5.23898 3.2834 4.85604C3.71269 4.47445 4.28582 4.26685 4.87498 4.26685H6.34998V3.0001C6.34998 2.77918 6.52906 2.6001 6.74998 2.6001C6.97089 2.6001 7.14998 2.77918 7.14998 3.0001V4.26685H13.85V3.0001C13.85 2.77918 14.0291 2.6001 14.25 2.6001ZM17.6 6.33351V9.26685H3.39998V6.33351C3.39998 6.01379 3.54245 5.69614 3.8149 5.45396C4.08888 5.21043 4.46957 5.06685 4.87498 5.06685H6.34998V6.33343C6.34998 6.55434 6.52906 6.73343 6.74998 6.73343C6.97089 6.73343 7.14998 6.55434 7.14998 6.33343V5.06685H13.85V6.33343C13.85 6.55434 14.0291 6.73343 14.25 6.73343C14.4709 6.73343 14.65 6.55434 14.65 6.33343V5.06685H16.125C16.5304 5.06685 16.9111 5.21043 17.1851 5.45396C17.4575 5.69614 17.6 6.01379 17.6 6.33351ZM17.6 10.0668H3.39998V16.3335C3.39998 16.6532 3.54245 16.9709 3.8149 17.2131C4.08888 17.4566 4.46957 17.6002 4.87498 17.6002H16.125C16.5304 17.6002 16.9111 17.4566 17.1851 17.2131C17.4575 16.9709 17.6 16.6532 17.6 16.3335V10.0668ZM10.5 12.6001C10.1595 12.6001 9.82478 12.7199 9.57132 12.9452C9.31632 13.1719 9.16248 13.4901 9.16248 13.8334C9.16248 14.1768 9.31632 14.495 9.57132 14.7217C9.82478 14.947 10.1595 15.0668 10.5 15.0668C10.8405 15.0668 11.1752 14.947 11.4286 14.7217C11.6836 14.495 11.8375 14.1768 11.8375 13.8334C11.8375 13.4901 11.6836 13.1719 11.4286 12.9452C11.1752 12.7199 10.8405 12.6001 10.5 12.6001ZM10.1028 13.5431C10.201 13.4559 10.3432 13.4001 10.5 13.4001C10.6567 13.4001 10.799 13.4559 10.8971 13.5431C10.9938 13.629 11.0375 13.7347 11.0375 13.8334C11.0375 13.9321 10.9938 14.0378 10.8971 14.1237C10.799 14.211 10.6567 14.2668 10.5 14.2668C10.3432 14.2668 10.201 14.211 10.1028 14.1237C10.0062 14.0378 9.96248 13.9321 9.96248 13.8334C9.96248 13.7347 10.0062 13.629 10.1028 13.5431Z"
                                    fill="#6C757D"
                                  ></path>
                                </svg>
                              </span>
                            </div>
                          </div>
                          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleApply}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="m-0 my-2 p-0 hr" />
                  <div>{"*Value in " + valueIn}</div>
                  <div className="row">
                    <div className="col-6">
                      <PieChart1
                        datasets={weekendAnalysisData
                          ?.map((y, i) => {
                            const index = portfolioOption?.findIndex(
                              (p) =>
                                p?.id !== undefined &&
                                p?.id?.toString() === y?.portfolio?.toString()
                            );
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            return catArray
                              ?.map((cat) => {
                                const categoryIndex = categoryOption?.findIndex(
                                  (c) =>
                                    c?.id !== undefined &&
                                    c?.id?.toString() === cat?.toString()
                                );
                                let data = y?.record
                                  ?.filter(
                                    (r) =>
                                      r?.category?.toString() === cat?.toString()
                                  )
                                  ?.filter(
                                    (r) =>
                                      r?.transyear?.toString() ===
                                      year?.getFullYear()?.toString()
                                  )
                                  ?.map((r) =>
                                    r?.sales ? parseFloat(r?.sales) : 0
                                  );

                                if (data?.length > 0) {
                                  return data;
                                } else return [];
                              })
                              ?.flat(1);
                          })
                          ?.flat(1)}
                        labels={(() => {
                          const label: string[] = [];

                          weekendAnalysisData?.forEach((y, i) => {
                            const index = portfolioOption?.findIndex(
                              (p) =>
                                p?.id !== undefined &&
                                p?.id?.toString() === y?.portfolio?.toString()
                            );
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            catArray?.forEach((cat) => {
                              const categoryIndex = categoryOption?.findIndex(
                                (c) =>
                                  c?.id !== undefined &&
                                  c?.id?.toString() === cat?.toString()
                              );
                              const categoryName =
                                categoryOption[categoryIndex]?.name;

                              let data = y?.record
                                ?.filter(
                                  (r) =>
                                    r?.category?.toString() === cat?.toString()
                                )
                                ?.filter(
                                  (r) =>
                                    r?.transyear?.toString() ===
                                    year?.getFullYear()?.toString()
                                )
                                ?.map((r) =>
                                  r?.sales ? parseFloat(r?.sales) : 0
                                );

                              if (data?.length > 0) {
                                label?.push(
                                  categoryName + "-" + year?.getFullYear()
                                );
                              }
                            });
                          });
                          return label;
                        })()}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Weekend Analysis`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt: string[] = [];
                          let subtxt1 = `\u3010Company\u3011: ${pname}`;
                          let subtxt2 = ``;
                          // if (locations?.length > 0) {
                          //   let locNameArr: string[] = [];
                          //   locations?.map((s) => {
                          //     locNameArr?.push(s?.label);
                          //   });
                          //   let localities = locNameArr?.join(", ");
                          //   subtxt1 += ` \u3010Locality\u3011: ${localities}`;
                          // }
                          if (location) {
                            subtxt1 += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt2 += ` \u3010Year\u3011: ${
                            year?.getFullYear() - 1
                          }`;
                          subtxt2 += ` \u3010Week\u3011: ${week}`;
                          subtxt?.push(subtxt1);
                          subtxt?.push(subtxt2);
                          return subtxt;
                        })()}
                        exportfilename={`WeekendAnalysis`}
                      />
                    </div>
                    <div className="col-6 ">
                      <PieChart1
                        datasets={weekendAnalysisData
                          ?.map((y, i) => {
                            const index = portfolioOption?.findIndex(
                              (p) =>
                                p?.id !== undefined &&
                                p?.id?.toString() === y?.portfolio?.toString()
                            );
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            return catArray
                              ?.map((cat) => {
                                const categoryIndex = categoryOption?.findIndex(
                                  (c) =>
                                    c?.id !== undefined &&
                                    c?.id?.toString() === cat?.toString()
                                );
                                let data = y?.record
                                  ?.filter(
                                    (r) =>
                                      r?.category?.toString() === cat?.toString()
                                  )
                                  ?.filter(
                                    (r) =>
                                      r?.transyear?.toString() ===
                                      (year?.getFullYear() - 1)?.toString()
                                  )
                                  ?.map((r) =>
                                    r?.sales ? parseFloat(r?.sales) : 0
                                  );

                                if (data?.length > 0) {
                                  return data;
                                } else return [];
                              })
                              ?.flat(1);
                          })
                          ?.flat(1)}
                        labels={(() => {
                          const label: string[] = [];

                          weekendAnalysisData?.forEach((y, i) => {
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            catArray?.forEach((cat) => {
                              const categoryIndex = categoryOption?.findIndex(
                                (c) =>
                                  c?.id !== undefined &&
                                  c?.id?.toString() === cat?.toString()
                              );
                              const categoryName =
                                categoryOption[categoryIndex]?.name;

                              let data = y?.record
                                ?.filter(
                                  (r) =>
                                    r?.category?.toString() === cat?.toString()
                                )
                                ?.filter(
                                  (r) =>
                                    r?.transyear?.toString() ===
                                    (year?.getFullYear() - 1)?.toString()
                                )
                                ?.map((r) =>
                                  r?.sales ? parseFloat(r?.sales) : 0
                                );

                              if (data?.length > 0) {
                                label?.push(
                                  categoryName + "-" + (year?.getFullYear() - 1)
                                );
                              }
                            });
                          });
                          return label;
                        })()}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Weekend Analysis `;

                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt: string[] = [];
                          let subtxt1 = `\u3010Company\u3011: ${pname}`;
                          let subtxt2 = ``;
                          // if (locations?.length > 0) {
                          //   let locNameArr: string[] = [];
                          //   locations?.map((s) => {
                          //     locNameArr?.push(s?.label);
                          //   });
                          //   let localities = locNameArr?.join(", ");
                          //   subtxt1 += ` \u3010Locality\u3011: ${localities}`;
                          // }
                          if (location) {
                            subtxt1 += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt2 += ` \u3010Year\u3011: ${
                            year?.getFullYear() - 1
                          }`;
                          subtxt2 += ` \u3010Week\u3011: ${week}`;
                          subtxt?.push(subtxt1);
                          subtxt?.push(subtxt2);
                          return subtxt;
                        })()}
                        exportfilename={`WeekendAnalysis`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-3">
                <div className="card-body">
                  <div className="row mb-1">
                    <div className="col-lg-6 col-sm-12">
                      <div className="float-start">
                        <h5 className="header-title mt-1">
                          <img src={tableIcon} alt="icon"></img>
                          Weekend Analysis
                        </h5>
                      </div>
                    </div>
                  </div>

                  <TransactionTable
                    data={[]}
                    {...getTableData()}
                    title=""
                    downloadCSV={true}
                    downloadPDF={true}
                    fileName="Hourly Sales Daywise Report"
                    limit={limit} //
                    setOffset={setOffset}
                    onClickCSV={handleCsvDownload}
                    onClickPDF={handlePdfDownload}
                    range={range}
                    valueInString={valueIn}
                    onPageNoChange={pag && (offset > 0||condition) ? handleApply : undefined}
                  handlePag={pag ? handlePag : undefined}
                  onOffchange={handleOff}
                    onSelectedRowsChange={handleSelectedRowsChange}
                  />
                </div>
              </div>
            </div>
          </div>

          {showModal && (
        <Modal
        headerText={"Weekend Analysis"}
        visible={showModal}
        onClose={() => setShowModal(false)}
        size="xl"
        centered
        classname="widget-container-single" > 
		<div className="card-body">
                  <div className="row">
                    <div className="col-6">
                      <PieChart1
                        datasets={weekendAnalysisData
                          ?.map((y, i) => {
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            return catArray
                              ?.map((cat) => {

                                let data = y?.record
                                  ?.filter(
                                    (r) =>
                                      r?.category?.toString() === cat?.toString()
                                  )
                                  ?.filter(
                                    (r) =>
                                      r?.transyear?.toString() ===
                                      year?.getFullYear()?.toString()
                                  )
                                  ?.map((r) =>
                                    r?.sales ? parseFloat(r?.sales) : 0
                                  );

                                if (data?.length > 0) {
                                  return data;
                                } else return [];
                              })
                              ?.flat(1);
                          })
                          ?.flat(1)}
                        labels={(() => {
                          const label: string[] = [];

                          weekendAnalysisData?.forEach((y, i) => {
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            catArray?.forEach((cat) => {
                              const categoryIndex = categoryOption?.findIndex(
                                (c) =>
                                  c?.id !== undefined &&
                                  c?.id?.toString() === cat?.toString()
                              );
                              const categoryName =
                                categoryOption[categoryIndex]?.name;

                              let data = y?.record
                                ?.filter(
                                  (r) =>
                                    r?.category?.toString() === cat?.toString()
                                )
                                ?.filter(
                                  (r) =>
                                    r?.transyear?.toString() ===
                                    year?.getFullYear()?.toString()
                                )
                                ?.map((r) =>
                                  r?.sales ? parseFloat(r?.sales) : 0
                                );

                              if (data?.length > 0) {
                                label?.push(
                                  categoryName + "-" + year?.getFullYear()
                                );
                              }
                            });
                          });
                          return label;
                        })()}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Weekend Analysis`;
                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt: string[] = [];
                          let subtxt1 = `\u3010Company\u3011: ${pname}`;
                          let subtxt2 = ``;
                          // if (locations?.length > 0) {
                          //   let locNameArr: string[] = [];
                          //   locations?.map((s) => {
                          //     locNameArr?.push(s?.label);
                          //   });
                          //   let localities = locNameArr?.join(", ");
                          //   subtxt1 += ` \u3010Locality\u3011: ${localities}`;
                          // }
                          if (location) {
                            subtxt1 += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt2 += ` \u3010Year\u3011: ${
                            year?.getFullYear() - 1
                          }`;
                          subtxt2 += ` \u3010Week\u3011: ${week}`;
                          subtxt?.push(subtxt1);
                          subtxt?.push(subtxt2);
                          return subtxt;
                        })()}
                        exportfilename={`WeekendAnalysis`}
                      />
                    </div>
                    <div className="col-6 ">
                      <PieChart1
                        datasets={weekendAnalysisData
                          ?.map((y, i) => {
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            return catArray
                              ?.map((cat) => {

                                let data = y?.record
                                  ?.filter(
                                    (r) =>
                                      r?.category?.toString() === cat?.toString()
                                  )
                                  ?.filter(
                                    (r) =>
                                      r?.transyear?.toString() ===
                                      (year?.getFullYear() - 1)?.toString()
                                  )
                                  ?.map((r) =>
                                    r?.sales ? parseFloat(r?.sales) : 0
                                  );

                                if (data?.length > 0) {
                                  return data;
                                } else return [];
                              })
                              ?.flat(1);
                          })
                          ?.flat(1)}
                        labels={(() => {
                          const label: string[] = [];

                          weekendAnalysisData?.forEach((y, i) => {
                            const catArray = y?.record
                              ?.map((y, j) => y?.category)
                              ?.filter(getOnlyUnique);

                            catArray?.forEach((cat) => {
                              const categoryIndex = categoryOption?.findIndex(
                                (c) =>
                                  c?.id !== undefined &&
                                  c?.id?.toString() === cat?.toString()
                              );
                              const categoryName =
                                categoryOption[categoryIndex]?.name;

                              let data = y?.record
                                ?.filter(
                                  (r) =>
                                    r?.category?.toString() === cat?.toString()
                                )
                                ?.filter(
                                  (r) =>
                                    r?.transyear?.toString() ===
                                    (year?.getFullYear() - 1)?.toString()
                                )
                                ?.map((r) =>
                                  r?.sales ? parseFloat(r?.sales) : 0
                                );

                              if (data?.length > 0) {
                                label?.push(
                                  categoryName + "-" + (year?.getFullYear() - 1)
                                );
                              }
                            });
                          });
                          return label;
                        })()}
                        colors={[
                          colors[0],
                          colors[1],
                          colors[2],
                          colors[3],
                          colors[4],
                          colors[5],
                          colors[6],
                          colors[7],
                        ]}
                        title={(() => {
                          const txt = `Weekend Analysis `;

                          return txt;
                        })()}
                        subtitle={(() => {
                          let subtxt: string[] = [];
                          let subtxt1 = `\u3010Company\u3011: ${pname}`;
                          let subtxt2 = ``;
                          // if (locations?.length > 0) {
                          //   let locNameArr: string[] = [];
                          //   locations?.map((s) => {
                          //     locNameArr?.push(s?.label);
                          //   });
                          //   let localities = locNameArr?.join(", ");
                          //   subtxt1 += ` \u3010Locality\u3011: ${localities}`;
                          // }
                          if (location) {
                            subtxt1 += `\u3010Locality\u3011: ${location}`;
                          }
                          subtxt2 += ` \u3010Year\u3011: ${
                            year?.getFullYear() - 1
                          }`;
                          subtxt2 += ` \u3010Week\u3011: ${week}`;
                          subtxt?.push(subtxt1);
                          subtxt?.push(subtxt2);
                          return subtxt;
                        })()}
                        exportfilename={`WeekendAnalysis`}
                      />
                    </div>
                  </div>
                </div>
		
		</Modal>)}
        </>
      )}
    </UserLayout>
  );
};
export default SalesWeekendAnalysisReport;
